import { useEffect, useState } from 'react';
import { NWClient } from '../../../client/NWClient';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const useDocumentContent = (
  docId: number,
  fileType: string,
  blobCreationAllowed?: boolean
) => {
  const { t } = useTranslation();
  const [fileBlobURL, setFileBlobURL] = useState<string>(null);
  const [pdfBlobMode, setPDFBlobMode] = useState<boolean>(true);
  const [fileLoading, setFileLoading] = useState<boolean>(false);
  const [params] = useSearchParams();
  const generateTemplateParam = params.get('generateTemplate');
  const editDocumentParam = params.get('editDocument');
  const creatingDocumentBlob = (open?: boolean) => {
    setFileLoading(true);
    NWClient.getDocumentBlob(docId)
      .then((res: string) => {
        setFileBlobURL(res);
        if (open) {
          window.open(res, '_blank');
        }
      })
      .catch((error) => {
        toast.error(error.message || t('messages.errorOccurred'));
      })
      .finally(() => setFileLoading(false));
  };
  useEffect(() => {
    if (fileType === 'pdf' && docId) {
      creatingDocumentBlob();
    }
  }, [docId, fileType]);
  useEffect(() => {
    if (generateTemplateParam || editDocumentParam) {
      setPDFBlobMode(false);
    }
  }, [generateTemplateParam, editDocumentParam]);
  return {
    fileBlobURL,
    fileLoading,
    creatingDocumentBlob,
    setPDFBlobMode,
    pdfBlobMode,
  };
};
